import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Container from '@material-ui/core/Container';
import Chip from '@material-ui/core/Chip';
import Typography from '@material-ui/core/Typography';
import { useIsMobile, useIsXLarge } from '../../../../../shared/theme';
import useFundsStateStore from '../../../common/funds-state-hook';

const useCardStyles = makeStyles({
  root: {
    border: '1px solid #D7DFE7',
    borderRadius: 9,
    // eslint-disable-next-line no-nested-ternary
    width: props => (props.isMobile ? '100%' : props.isXLarge ? 'calc((100% - 36px)/4)' : 'calc((100% - 12px)/2)'),

    '&:hover': {
      cursor: 'pointer',
      border: '1px solid #D7DFE7',
      boxShadow: '0px 20px 25px -5px rgba(0, 0, 0, 0.1), 0px 10px 10px -5px rgba(0, 0, 0, 0.04)',
    },

    '&.active': {
      border: '1px solid #19202D',
      backgroundColor: props => props.activeBgColor,
    },
  },
});

const useContainerStyles = makeStyles({
  root: {
    border: '1px solid transparent',
    borderRadius: 9,
    padding: 0,
    height: '100%',

    '&.active': {
      border: '1px solid #19202D',
      backgroundColor: props => props.activeBgColor,
    },
  },
});

const useChipStyles = makeStyles({
  root: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: props => props.typeBgColor,
    borderRadius: 4,
    height: 27,
    width: 'fit-content',

    '& > .MuiChip-label': {
      color: props => props.typeColor,
      fontFamily: 'Texta,Arial,Helvetica,sans-serif',
      fontSize: 19,
      fontWeight: 700,
      textTransform: 'uppercase',
    },
  },
});

const Description = withStyles(() => ({
  root: {
    marginTop: 32,
    color: '#627484',
    fontFamily: 'Texta,Arial,Helvetica,sans-serif',
    fontSize: 17,
    lineHeight: '120%',
  },
}))(Typography);

export default function FundTypeCard(props) {
  const isMobile = useIsMobile();
  const isXLarge = useIsXLarge();
  const set = useFundsStateStore(state => state.set);
  const fundTypes = useFundsStateStore(state => state.filters.fundTypes);
  const { type, label, description } = props;
  const selected = fundTypes.includes(type);
  const cardClasses = useCardStyles({ ...props, isMobile, isXLarge });
  const containerClasses = useContainerStyles({ ...props, isMobile, isXLarge });
  const chipClasses = useChipStyles({ ...props, isMobile, isXLarge });

  const toggleSelection = () => {
    set(state => {
      state.filters.fundTypes = selected ? [] : [type];
    });
  };

  return (
    <Card className={`${cardClasses.root} ${selected ? 'active' : ''}`} variant="outlined" onClick={toggleSelection}>
      <Container className={`${containerClasses.root} ${selected ? 'active' : ''}`}>
        <CardContent>
          <Chip className={chipClasses.root} label={label} />
          <Description>{description}</Description>
        </CardContent>
      </Container>
    </Card>
  );
}

FundTypeCard.propTypes = {
  label: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};
